import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { isLoggedIn, selectToken } from '../login/loginSlice';
import { toggleCreateUserForm } from '../createUserForm/createUserFormSlice.js';
import { loadAllUsers, loadingUsers, loadUsers, selectUsers } from './manageUsersSlice.js';
import { changeEditUserBranch, changeEditUserId, changeEditUserName, changeEditUserRole, toggleEditUserForm } from '../editUserForm/editUserFormSlice.js';
import { loadAllBranches, loadBranches, selectBranches } from '../manageBranches/branchesSlice.js';

import './ManageUsers.css';

import Sidebar from '../../components/sidebar/Sidebar';
import CreateUserForm from '../createUserForm/CreateUserForm.js';
import EditUserForm from '../editUserForm/EditUserForm.js';
import { selectUser } from '../home/userSlice.js';
import { changeSearchMode, changeSearchTarget, changeSearchTargetOptions, selectFilters, selectSearchMode } from '../searchBar/searchBarSlice.js';
import SearchBar from '../searchBar/SearchBar.js';
import Filter from '../../components/filter/Filter.js';

export default function ManageUsers() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const token = useSelector(selectToken);

    const loggedIn = useSelector(isLoggedIn);
    const users = useSelector(selectUsers);
    const usersLoading = useSelector(loadingUsers);
    const branches = useSelector(selectBranches);

    const userInfo = useSelector(selectUser);
    const userRole = userInfo.userRole;
    const bankId = userInfo.bankId;
    
    const searchMode = useSelector(selectSearchMode);
    const searchFilters = useSelector(selectFilters);
    const userFilters = searchFilters.filter(filter => filter.searchMode === 'user');

    const filteredUsers = userFilters.length < 1 ? users : users.filter(user => {
        let filterCheck = true;

        userFilters.forEach(filter => {
            if (filter.active && filterCheck) {
                if (filter.searchTarget === 'User Id') {
                    filterCheck = user.username.includes(filter.searchTerm);
                } else if (filter.searchTarget === 'Name') {
                    filterCheck = user.name.includes(filter.searchTerm);
                } else if (filter.searchTarget === 'Display Name') {
                    filterCheck = user.displayName && user.displayName.includes(filter.searchTerm);
                } else if (filter.searchTarget === 'User Role') {
                    filterCheck = user.userRole.includes(filter.searchTerm);
                } else if (filter.searchTarget === 'Bank Id') {
                    filterCheck = user.bankId && user.bankId.includes(filter.searchTerm);
                } else if (filter.searchTarget === 'Branch Name') {
                    if (user.branchId) {
                        const branchName = branches.find(branch => branch.branchId === user.branchId);
                        filterCheck = branchName.branchName.includes(filter.searchTerm);    
                    } else {
                        filterCheck = false;
                    }
                }
            }
        })
        return filterCheck;
    })

    useEffect(() => {
        if (!loggedIn) {
            navigate('../login');
        }
    }, [navigate, loggedIn])

    useEffect(() => {
        if (userRole === 'ADMIN') {
            dispatch(loadBranches({bankId, token}));
            dispatch(loadUsers({bankId, token}));
        } else if (userRole === 'SUPERADMIN') {
            dispatch(loadAllBranches(token));
            dispatch(loadAllUsers(token));
        }
        
    }, [dispatch, userRole, bankId, token]);

    useEffect(() => {
        if (searchMode !== 'user') {
            dispatch(changeSearchMode('user'));
            dispatch(changeSearchTargetOptions(['User Id', 'Name', 'Display Name', 'User Role', 'Bank Id', 'Branch Name']));
            dispatch(changeSearchTarget('Name'));
        }
    })

    const handleCreateUserButtonClick = () => {
        dispatch(toggleCreateUserForm());
    }

    const handleEditUserButtonClick = (event) => {
        const editUsername = event.target.value;
        const userToEdit = users.find(user => user.username.toString() === editUsername);
        dispatch(changeEditUserId(userToEdit.username));
        dispatch(changeEditUserName(userToEdit.name));
        dispatch(changeEditUserRole(userToEdit.userRole));
        if (userToEdit.userRole === 'USER') {
            dispatch(changeEditUserBranch(userToEdit.branchId));
        }
        dispatch(toggleEditUserForm());
    }

    return (
        <main>
            <Sidebar />
            <section className='manage-users'>
                <div>
                    <h2>Manage Users</h2>
                    
                </div>
                <div className='user-header'>
                    <SearchBar />
                    <button onClick={handleCreateUserButtonClick}>Create User</button>
                </div>
                <div className='filters'>
                    {userFilters.map(filter => <Filter filter={filter} />)}
                </div>
                {usersLoading ? <h3>Loading Users...</h3> :
                    <table>
                        <thead>
                            <tr>
                                <th>Edit</th>
                                <th>User Id</th>
                                <th>Name</th>
                                <th>Display Name</th>
                                <th>User Role</th>
                                {userRole === 'SUPERADMIN' ? <th>Bank Id</th> : ""}
                                <th>Branch</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredUsers.map((user) => {
                                let branchName = '';
                                if (user.userRole === 'USER') {
                                    branchName = branches.find(branch => branch.branchId === user.branchId);
                                }
                                
                                return (
                                    <tr key={user.username}>
                                        <td><button onClick={handleEditUserButtonClick} value={user.username}>Edit</button></td>
                                        <td>{user.username}</td>
                                        <td>{user.name}</td>
                                        <td>{user.displayName}</td>
                                        <td>{user.userRole}</td>
                                        {userRole === 'SUPERADMIN' ? <td>{user.bankId}</td> : ""}
                                        <td>{branchName !== undefined ? branchName.branchName : ""}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>}
            </section>
            <CreateUserForm />
            <EditUserForm />
        </main>
    )
}